export default __webpack_public_path__ + "static/media/doc.0b1a1d4e.svg";